import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { set_favorite_product } from "../redux/actions/product";
import { toast } from "react-toastify";
import defaultImage from '../assets/image/logo.png';


function ItemProducto({ product, set_favorite_product, updateFavoriteStatus }) {

    const isOutOfStock = product.stock <= 0;
    const isFavorite = product.is_favorite === 1;
    const userLoggedIn = !!localStorage.getItem("token");

    const setFavorite = async () => {
        await set_favorite_product(product.id, !isFavorite);
        // Actualizamos el estado global

        toast.success(
            isFavorite ? "Producto eliminado de favoritos" : "Producto agregado a favoritos",
            {
                position: "top-right",
                autoClose: 3000, // Cerrar en 3 segundos
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            }
        );

        // Aquí actualizamos el estado de la lista de productos
        updateFavoriteStatus(product.id, !isFavorite);  // Le pasamos el id del producto y su nuevo estado de favorito
    };

    const CardContent = (
        <div className={`bg-white border rounded-lg shadow-md relative overflow-hidden transform transition-transform duration-300 ${isOutOfStock ? "grayscale opacity-80 cursor-default" : "hover:scale-105"}`}>

            {userLoggedIn && (
                <button
                    className={`btn-favorite ${isFavorite ? "text-red-500" : "text-gray-500"}`}
                    onClick={(e) => {
                        e.preventDefault();     // Evita que se siga el enlace
                        e.stopPropagation();    // Detiene la propagación del evento hacia el <Link>
                        setFavorite();
                    }}>
                    <FontAwesomeIcon icon={faHeart} className="text-lg" />
                </button>
            )}
            {
                product.has_offer && !isOutOfStock ?
                    (
                        <span className="absolute top-0 right-0 bg-brand-orange text-white sm:text-xs text-[10px] font-bold px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-bl-lg z-10">
                            <>
                                {Math.floor(product.offer_percentage_price)}%
                                <br />
                                Off
                            </>
                        </span>
                    ) : null
            }

            {isOutOfStock && (
                <span className="absolute top-0 right-0 bg-gray-500 text-white sm:text-xs text-[10px] font-bold px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-bl-lg z-10">
                    Agotado
                </span>
            )}

            <img
                src={product.first_image || defaultImage}
                onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
                alt={product.name}
                className="w-full bg-white object-contain aspect-[1/1] mb-1 sm:mb-2"
            />
            <div className="flex flex-col justify-between px-2 sm:px-3 pb-2 sm:pb-3 min-h-[80px]">
                <p className="mb-1 text-secondary text-xs sm:text-sm line-clamp-2">{product.name}</p>

                {product.has_offer ?

                    <p className="font-bold mb-0 text-gray-900 text-sm sm:text-base">
                        Bs {product.offer_price} <span className="text-gray-400 line-through text-[10px] sm:text-xs">Bs {product.previous_price}</span>
                    </p>
                    :
                    <p className="font-bold mb-0 text-gray-900 text-sm sm:text-base">
                        Bs {product.price}
                    </p>

                }
            </div>
            <div className="my-1.5 mx-1.5 sm:my-2 sm:mx-2" >
                <button
                    className={`${isOutOfStock ? "bg-gray-400 cursor-default" : "bg-brand-blue hover:bg-blue-700 transition-colors"} text-white font-medium px-2 py-1.5 sm:px-4 sm:py-2 rounded-lg text-xs sm:text-sm w-full`}
                    disabled={isOutOfStock}
                >
                    {isOutOfStock ? "Agotado" : "Ver producto"}
                </button>
            </div>
        </div>
    );

    if (isOutOfStock) {
        return CardContent;
    }

    return (
        <Link className="no-underline" to={`/${product.store_slug}/${product.slug}`}>
            {CardContent}
        </Link>
    );
}

// Conectamos el componente a Redux
export default connect(null, { set_favorite_product })(ItemProducto);
